import { render, staticRenderFns } from "./qianhuiduo.vue?vue&type=template&id=578fd8a5&scoped=true"
import script from "./qianhuiduo.vue?vue&type=script&lang=js"
export * from "./qianhuiduo.vue?vue&type=script&lang=js"
import style0 from "./qianhuiduo.vue?vue&type=style&index=0&id=578fd8a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578fd8a5",
  null
  
)

export default component.exports